/**
 * Returns true when the order must be signed by someone other than its owner
 * (the initiator) — i.e. it has been sent to a co-signer.
 *
 * @param signatories CMIDs (or signatures) of everyone who must sign the order.
 * @param ownerId The order owner / initiator (CMID for external users, the
 *   Storebrand signature for internal users).
 */
export const orderHasCosigners = (
  signatories: string[],
  ownerId: string,
): boolean => signatories.some((signatory) => signatory !== ownerId);
